import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';
import AdminModal from '../../components/AdminModal/AdminModal';
import templateTypes from '../../constants/templateTypes';

import { getAllEmailTemplates, getEmailTemplate, updateCustomTemplate, deleteCustomTemplate } from '../../services/customTemplate'; 

import { showAlert } from '../../store/ducks/alert';

import { Add as AddIcon, Edit as EditIcon, HighlightOff } from '@material-ui/icons';
import { CircularProgress, Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const CustomTemplates = ({ location, match }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [isSearching, setIsSearching] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [formData, setFormData] = useState({});
  const [remove, setRemove] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [customTemplate, setCustomTemplate] = useState([]);
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayCustomTemplate(currentPage);
  }, [isSearching, isOrdering, page]);

  const headers = ['id', 'customTemplateId', 'isEnabled', 'createdAt', 'type', 'updatedAt', 'deletedAt'];
  const SearchBoxHeaders = ['id', 'type'];

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const displayCustomTemplate = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      const { data: customTemplate } = await getAllEmailTemplates(currentPage || page, params);

      setCustomTemplate(customTemplate.rows);
      setTotalItems(customTemplate.count);
      setTotalPages(customTemplate.pages);
      setPage(customTemplate.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const customActions = [
    {
      icon: <HighlightOff />,
      action: item => {
        setFormData(item);
        setRemove(true);
      },
    },
    {
      icon: <EditIcon />,
      action: item => {
        handleOpenUpdate(item);
      },
    },
  ];

  const handleOpenUpdate = async item => {
    if (item.enabled === '⛔️ Não') item.enabled = 'false';
    if (item.enabled === '✅ Sim') item.enabled = 'true';
    const { data } = await getEmailTemplate(item.id);
    setIsUpdating(true);
    setFormData({ ...item, ...data.dataValues });
    setOpen(true);
  };

  const handleSubmitForm = async dataForm => {
    try {
      const { file, type } = dataForm;
      let { isEnabled } = dataForm;
      if (isEnabled === '⛔️ Não') isEnabled = 'false';
      if (isEnabled === '✅ Sim') isEnabled = 'true';

      const fileToSend = new FormData()
      fileToSend.append('file', file);
      fileToSend.append('isEnabled', isEnabled);
      fileToSend.append('type', type);
      await updateCustomTemplate(dataForm.id, fileToSend);
      setIsUpdating(false);

      dispatch(showAlert('success', 'Success! 🔥'));
      window.location = '/custom-template';
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something went wrong. 😔'));
    }
  };

  const handleCloseModal = () => {
    setFormData({});
    setOpen(false);
  };

  const handleCloseRemoveAlert = () => {
    setRemove(false);
  };

  const handleSubmitDelete = async () => {
    try {
       await deleteCustomTemplate(formData.id);
       dispatch(showAlert('success', 'Template deleted!'));
       window.location.reload();
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not delete this template. 😔'));
    }
  };

  const modalColumns = [
    { label: 'html', prop: 'file', type: 'file', required: true },
    { label: 'isEnabled', prop: 'isEnabled', type: 'text', required: true },
    {
      label: 'type',
      prop: 'type',
      type: 'select',
      required: true,
      options: templateTypes,
    },
    { label: 'subject', prop: 'subject', type: 'text', required: true },
  ];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Email Templates ({totalItems})</h1>
        {open ? (
          <AdminModal
            columns={modalColumns}
            data={formData}
            modalName={'Update Email Template'}
            onSubmit={handleSubmitForm}
            onClose={handleCloseModal}
            isUpdating={isUpdating}
          />
        ) : (
          ''
        )}
        <SearchBox
          selectItems={SearchBoxHeaders}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          setIsOrdering={setIsOrdering}
        />
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={customTemplate}
        customActions={customActions}
        bodyColumn={headers}
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
      {remove ? (
        <div className="unsubscribe-container">
          <div className="unsubscribe-container-top">
            <h2>Are you sure you want to delete this template?</h2>

            <IconButton onClick={handleCloseRemoveAlert}>
              <CloseIcon />
            </IconButton>
          </div>
          <div>
            <h4>{formData.id}</h4>
          </div>
          <Button onClick={handleSubmitDelete} variant="contained" className="modal-btn">
            Yes
          </Button>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default CustomTemplates;
